import React from 'react';
import '../style/navStyle.css';
import Button from './Button';
import Sentence from './smallComponent/Sentence';
import Image from './Image';
import BodyImage from '../images/BodyImage.png';
import '../style/fBody.css';;




export default function First(){
    return(
        <div  className="firstB">
            <div className="left">
                <Sentence header='Next generation digital banking' paragraph='Take your financial life online. Your easybank account will be a one stop-shop for spending saving, budgeting, investing and much more.'/>
                
                <Button type="submit" value="Request Invite" />
            </div>
            <div className="fright">
               <Image className="fimg" src={BodyImage}/>
            </div>
        </div>
    )
}